import store from '@/store/index'

export default {}

/**
 * Returns the full state object for the specified module.
 *
 * @param module String
 *
 * @returns Object
 */
export const get = (module) => {
  return store.getters[`${module}/get`]
}

/**
 * Returns an array of attachments for the specified module.
 *
 * @param module String
 *
 * @returns Array
 */
export const attachments = (module) => {
  return store.getters[`${module}/attachments`]
}

/**
 * Returns the number of attachments.
 *
 * @param module String
 *
 * @returns Number
 */
export const attachmentsCount = (module) => {
  return store.getters[`${module}/attachments`].length
}

/**
 * Finds and returns a attachment by id or undefined if not found.
 *
 * @param module String
 * @param id     Number
 *
 * @returns Array
 */
export const attachmentById = (module, id) => {
  return store.getters[`${module}/attachments`].find(
    attachment => attachment.id === id
  )
}

/**
 * Finds and returns a attachment by index or undefined if not found.
 *
 * @param module String
 * @param index  Number
 *
 * @returns Array
 */
export const attachmentByIndex = (module, index) => {
  let attachments = store.getters[`${module}/attachments`]
  if (index < attachments.length) {
    return attachments[index]
  } else {
    return undefined
  }
}

/**
 * Returns the current form warning.
 *
 * @param module String
 *
 * @return string
 */
export const warning = (module) => {
  return store.getters[`${module}/warning`]
}

/**
 * Returns the newest (last) attachment in the list of attachments.
 *
 * @param module String
 *
 * @returns Object
 */
export const newest = (module) => {
  return attachments[store.getters[`${module}/get`].length - 1]
}

/**
 * API request to create a new attachment. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const post = (module, payload) => {
  return store.dispatch(`${module}/post`, payload)
}

/**
 * API request to delete an existing attachment. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const deleteAttachment = (module, payload) => {
  return store.dispatch(`${module}/delete`, payload)
}

/**
 * Set an array of attachments.
 *
 * @param module   String
 * @param attachments Array
 */
export const setAttachments = (module, attachments) => {
  store.commit(`${module}/setAttachments`, attachments)
}

/**
 * Add a new attachment.
 *
 * @param module  String
 * @param attachment Object
 */
export const add = (module, attachment) => {
  store.commit(`${module}/add`, attachment)
}

/**
 * Find a attachment by index in the array of attachments and updates it.
 *
 * @param module  String
 * @param attachment Object
 * @param index   Number
 */
export const updateByIndex = (module, attachment, index) => {
  store.commit(`${module}/updateByIndex`, { attachment, index })
}

/**
 * Updates the last attachment that was added.
 *
 * @param module  String
 * @param attachment Object
 */
export const updateNewest = (module, attachment) => {
  store.commit(`${module}/updateNewest`, attachment)
}

/**
 * Find a attachment by id and remove it.
 *
 * @param module  String
 * @param id      Number
 */
export const removeById = (module, id) => {
  store.commit(`${module}/removeById`, id)
}

/**
 * Find a attachment by id and remove it.
 *
 * @param module  String
 * @param index   Number
 */
export const removeByIndex = (module, index) => {
  store.commit(`${module}/removeByIndex`, index)
}

/**
 * Clears the attachments from the state.
 *
 * @param module String
 */
export const purge = (module) => {
  store.commit(`${module}/purge`)
}

/**
 * Sets the isAdding form state.
 *
 * @param module   String
 * @param isAdding Boolean
 */
export const setIsAdding = (module, isAdding) => {
  store.commit(`${module}/setIsAdding`, isAdding)
}

/**
 * Sets the isDeleting form state.
 *
 * @param module   String
 * @param isDeleting Boolean
 */
export const setIsDeleting = (module, isDeleting) => {
  store.commit(`${module}/setIsDeleting`, isDeleting)
}

/**
 * Sets the form warning.
 *
 * @param module  String
 * @param warning String
 */
export const setWarning = (module, warning) => {
  store.commit(`${module}/setWarning`, warning)
}

/**
 * Resets the form state.
 *
 * @param module   String
 */
export const resetFormState = (module) => {
  store.commit(`${module}/resetFormState`)
}



// WEBPACK FOOTER //
// ./src/store/attachments/attachments.helpers.js